import React from "react";
import { Create } from "react-admin";
import { EditActions } from "../../common/form/FormActions";
import { EldForm } from "./EldForm";
import { useNotification } from "../../../common/hooks/useNotification";
import { useFieldPermissions } from "../../../common/hooks/useFieldPermissions";
import { protectedEntities } from "../../../common/auth/permissions";
import { FieldPermissionsContext } from "../../common/field-permissions/FieldPermissionsContext";

interface IEldCreateProps {}

export const EldCreate = (props: IEldCreateProps) => {
  const notify = useNotification(props, "createSuccess");
  const fieldPermissions = useFieldPermissions(
    protectedEntities.EldDevice,
    (x) => x.create
  );
  return (
    <FieldPermissionsContext.Provider value={fieldPermissions}>
      <Create
        {...props}
        actions={<EditActions />}
        onSuccess={notify}
        title="resources.admin-elds.title.create">
        <EldForm />
      </Create>
    </FieldPermissionsContext.Provider>
  );
};
